import { render, staticRenderFns } from "./PreviewSetting.vue?vue&type=template&id=58086a96&scoped=true&"
import script from "./PreviewSetting.vue?vue&type=script&lang=ts&"
export * from "./PreviewSetting.vue?vue&type=script&lang=ts&"
import style0 from "./PreviewSetting.vue?vue&type=style&index=0&id=58086a96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58086a96",
  null
  
)

export default component.exports